import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/lib/auth";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import WikiList from "@/pages/WikiList";
import WikiPage from "@/pages/WikiPage";
import Contribute from "@/pages/Contribute";
import Admin, { PageEditor } from "@/pages/Admin";
import ItemsList, { ItemDetail } from "@/pages/Items";
import BadgesList, { BadgeDetail } from "@/pages/Badges";
import Skills from "@/pages/Skills";
import World from "@/pages/World";
import Missions from "@/pages/Missions";
import Forum, { ForumPostDetail } from "@/pages/Forum";
import ForumNew from "@/pages/ForumNew";
import Discord from "@/pages/Discord";
import Profile from "@/pages/Profile";
import Stats from "@/pages/Stats";
import Rankings from "@/pages/Rankings";
import About from "@/pages/About";
import Roadmap from "@/pages/Roadmap";
import PageviewTracker from "@/components/PageviewTracker";
import WikiGate from "@/components/WikiGate";

function AppRouter() {
  return (
    <Layout>
      <PageviewTracker />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/wiki" element={<WikiGate><WikiList /></WikiGate>} />
        <Route path="/wiki/items" element={<WikiGate><ItemsList /></WikiGate>} />
        <Route path="/wiki/items/:slug" element={<WikiGate><ItemDetail /></WikiGate>} />
        <Route path="/wiki/badges" element={<WikiGate><BadgesList /></WikiGate>} />
        <Route path="/wiki/badges/:slug" element={<WikiGate><BadgeDetail /></WikiGate>} />
        <Route path="/wiki/skills" element={<WikiGate><Skills /></WikiGate>} />
        <Route path="/wiki/world" element={<WikiGate><World /></WikiGate>} />
        <Route path="/wiki/missions" element={<WikiGate><Missions /></WikiGate>} />
        <Route path="/wiki/stats" element={<WikiGate><Stats /></WikiGate>} />
        <Route path="/wiki/:slug" element={<WikiGate><WikiPage /></WikiGate>} />
        <Route path="/forum" element={<Forum />} />
        <Route path="/forum/new" element={<ForumNew />} />
        <Route path="/forum/:id" element={<ForumPostDetail />} />
        <Route path="/discord" element={<Discord />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/about" element={<About />} />
        <Route path="/rankings" element={<Rankings />} />
        <Route path="/roadmap" element={<Roadmap />} />
        <Route path="/contribute" element={<Contribute />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/new" element={<PageEditor />} />
        <Route path="/admin/edit/:slug" element={<PageEditor />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}
